import mixpanel from 'mixpanel-browser';
import { createAction, handleActions } from 'redux-actions';
import Agent from '../../api/Agent';
import mixpanelConstants from '../../constants/mixpanel';
import documentStatusConstants from '../../constants/documentStatus';
import { handleError } from '../user';
import { setReasonValue } from '../shiftdetail';

export const setPendingRequests = createAction('SET_PENDING_REQUESTS');
export const setOldRequests = createAction('SET_OLD_REQUESTS');
export const setRequestSort = createAction('SET_SORT');
export const setRequestSortOrder = createAction('SET_SORT_ORDER');
export const setRequestPageNumber = createAction('SET_REQUEST_PAGE_NUMBER');
export const setSelectedIndex = createAction('SET_SELECTED_INDEX');
export const setOpenReqReasons = createAction('SET_OPEN_REQ_REASONS');

const initialState = {
	oldRequests: {},
	openReqReasons: false,
	page_no: 1,
	pendingRequests: {},
	selectedIndex: 0,
	sort: 'dateSubmitted',
	sortorder: 'desc'
};

export default handleActions(
	{
		SET_OLD_REQUESTS: (state, action) => ({ ...state, oldRequests: action.payload }),
		SET_OPEN_REQ_REASONS: (state, action) => ({ ...state, openReqReasons: action.payload }),
		SET_PENDING_REQUESTS: (state, action) => ({ ...state, pendingRequests: action.payload }),
		SET_REQUEST_PAGE_NUMBER: (state, action) => ({ ...state, page_no: action.payload }),
		SET_SELECTED_INDEX: (state, action) => ({ ...state, selectedIndex: action.payload }),
		SET_SORT: (state, action) => ({ ...state, sort: action.payload }),
		SET_SORT_ORDER: (state, action) => ({ ...state, sortorder: action.payload })
	},
	initialState
);

export const fetchPendingRequests = () => {
	return function (dispatch, getState) {
		Agent.getPendingRequests(getState().requests.page_no, getState().requests.sort, getState().requests.sortorder).then(
			(response) => {
				if (response.ok) {
					dispatch(setPendingRequests(response.data));
				} else {
					dispatch(handleError(response));
				}
			}
		);
	};
};

export const fetchOldRequests = () => {
	return function (dispatch, getState) {
		Agent.getOldRequests(getState().requests.page_no, getState().requests.sort, getState().requests.sortorder).then(
			(response) => {
				if (response.ok) {
					dispatch(setOldRequests(response.data));
				} else {
					dispatch(handleError(response));
				}
			}
		);
	};
};

export const setPageNumber = (pageNo) => {
	return function (dispatch) {
		dispatch(setRequestPageNumber(pageNo));
	};
};

export const changeRequestApproveState = (user_id, req_id, user_req_id, state, type, option) => {
	return function (dispatch, getState) {
		let reason = getState().shiftdetail.reasonValue;
		let currentRequest = getState().requests.pendingRequests.requests.find(
			(item) => item.user_id == user_id && item.requirement_id == req_id
		);
		let title = currentRequest.title;
		let userName = currentRequest.name;
		Agent.changeRequesrApproveState(user_id, req_id, user_req_id, state, reason, option).then((response) => {
			if (response.ok) {
				if (state == true) {
					if (type == 'document') {
						trackDocumentStatus(
							title,
							mixpanelConstants.APPROVE_NURSE_REQUIREMENT_DOCS,
							documentStatusConstants.APPROVED,
							user_id,
							getState().user.id,
							userName
						);
						alert('Requirement successfully approved');
					} else {
						trackDocumentStatus(
							title,
							mixpanelConstants.APPROVE_NURSE_REQUIREMENT_DOCS,
							documentStatusConstants.APPROVED,
							user_id,
							getState().user.id,
							userName
						);
						alert('Requirement successfully scheduled');
					}
				} else if (state == false) {
					trackDocumentStatus(
						title,
						mixpanelConstants.REJECT_NURSE_REQUIREMENT_DOCS,
						documentStatusConstants.REJECTED,
						user_id,
						getState().user.id,
						userName
					);
					alert('Request rejected');
					dispatch(setReasonValue(''));
				}
				dispatch(fetchPendingRequests());
				dispatch(fetchOldRequests());
			} else {
				alert(response.data ? response.data : "Couldn't update user requirement");
			}
		});
	};
};

export const trackDocumentStatus = (title, mixpanelConstant, documentStatus, user_id, loggedUserId, userName) => {
	let peoplePropertyTitle = `${title} Status`.toLowerCase().replace(/ /g, '_');
	mixpanel.track(mixpanelConstant, {
		documentTitle: title,
		nurseId: user_id,
		nurseName: userName,
		origin: 'Pending Request'
	});
	mixpanel.identify(user_id);
	mixpanel.people.set({
		[peoplePropertyTitle]: documentStatus
	});
	mixpanel.identify(loggedUserId);
};
